module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.d2a55d331bdd1a7ea97a.woff";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.woff?v=2.2.0
// module id = ../../../../material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.woff?v=2.2.0
// module chunks = 2